<template>
	<div class='main-mybody' style="padding-top: 1rem;" id='homewaichu'>
		<a-row>
			<a-col :span='11'>
				<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules' style="width: 100%;" hideRequiredMark>
					<div class='look_g'><div></div>外出時間</div>
					<div style="display:flex;">
						<div slot="label" v-html='"日&emsp;期："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
						<a-date-picker v-model="form.gooutdate" @change="dateClick(1)" :disabledDate="disabledDate1" style="width:100%" placeholder=''/>
					</div>
					<div style="display:flex;margin-top: 20px;">
						<div slot="label" v-html='"時&emsp;間："' style="display: flex;color: #000000;font-size: 0.75rem;align-items: center;flex-shrink: 0;"></div>
						<div style="width: 100%;display: flex;align-items: center;">
							<a-select v-model="form.begintime" class='warp_width'>
								<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
									:value="item.value">
									{{item.text }}
								</a-select-option>
							</a-select>
							<div style="display: inline-block;margin: 0 0.5rem;">一</div>
							<a-select v-model="form.endtime" class='warp_width'>
								<a-select-option v-for="(item) in admintypeArrs" :key="item.key+'a'"
									:value="item.value">{{item.text}}</a-select-option>
							</a-select>
						</div>
					</div>
					<div class='main-wid' style="width:100%;margin-top: 20px;"></div>
					<div>
						<div class='look_g'><div></div>外出事由</div>
						<a-textarea style='width: 100%;' v-model="form.cause" placeholder=" " :auto-size="{ minRows: 4, maxRows: 4 }" />	 
					</div>
				</a-form-model>
			</a-col>
			<a-col :span='2'></a-col>
			<a-col :span='11'>
				<div>
					<div class='look_g'><div></div>外出地點</div>
					<a-input v-model="form.address" class='warp_width' style='width: 100%;' />
				</div>
				<div class='main-wid' style="width:100%;margin-top: 20px;"></div>
				<div>
					<div class='look_g'><div></div>外出信息</div>
					<div v-if='!form.cardpic'>
						<a-upload name="avatar" class="avatar-uploader" :show-upload-list="false"
							action="https://www.mocky.io/v2/5cc8019d300000980a055e76" :before-upload="beforeUpload"
							@change="handleChange" style="width: 100%;">
							<a-button class='warp_bbtn' style="width: 100%;" size="large" :disabled="showflag !=1 ">+ 上傳名片</a-button>
						</a-upload>
					</div>
					<a-button v-else  class='warp_bbtn' size="large">上傳成功</a-button>
				</div>
				<div class='main-wid' style="width:100%;margin-top: 20px;"></div>
				<div style="margin-bottom:20px;">
					<div class='look_g' style="margin-bottom:1rem"><div></div>外出總結</div>
					<a-input v-model="form.summarize" placeholder='請填寫外出總結' :disabled="showflag !=1 " class='warp_width' style='width: 100%;' />
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import rl from './rlmate.vue';
	import App from '@/assets/app.js';
	import moment from 'moment';
	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}
	export default {
		props: ['pared','applyid'],
		components: {
			rl
		},
		data() {
			return {
				fourthqty: '',
				visible: true,
				ishand: false,
				showflag: '',
				rules: {},
				formview: {
					createtime: "",
					department: "",
					position: "",
					realname: "",
					sex: 0,
				},
				form: {
					"type": 2, //類型 1 假期申請 2 外出 3加班
					//"asktype":1,   // 1年假 2病假 3婚假 4產假 5陪產假 6喪假 7無薪休假 0其他
					// "otherasktype":"",//  其他請假形式
					"cause": "",
					address: '',
					"gooutdate": "",
					"begintime": "9:00",
					// "enddate":"2021-6-7",
					"endtime": "18:00",
					issave:'',//1 儲存 2 提交
					summarize:'',
					cardpic:'',
				},
				admintypeArrs: [],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		created() {
			let _this = this;
			_this.handimg()
		},
		mounted() {
			if(this.pared.applyid){
				this.handimg()
			}
			let b = ['00', '15', '30', '45'];
			let arr = []
			for (let a = 9; a < 18; a++) {
				b.map(ev => {
					arr.push({
						text: a + ':' + ev,
						value: a + ':' + ev,
					})
				})
			}
			arr.push({
				text: '18:00',
				value: '18:00',
			})
			this.admintypeArrs = arr
			for (let i = 0; i < this.admintypeArrs.length; i++) {
				this.$set(this.admintypeArrs[i],'index',i)
			}
			console.log(this.admintypeArrs);
		},
		methods: {
			disabledDate1 (current) {
				return current && current < moment().subtract(1, 'days').endOf('day')
			},
			dateClick(val){
				this.form.gooutdate = App.oDate.secsTime3(this.form.gooutdate._d);
				
			},
			beforeUpload(file) {
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				}
				return isJpgOrPng && isLt2M;
			},
			handleChange(info) {
				getBase64(info.file.originFileObj).then(res => {
					this.form.cardpic = res
					console.log(this.form.cardpic);
				})
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || this.applyid,
						token: this.$store.state.token,
						applytype:3
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						this.showflag = res.data.showflag
						this.form = res.data
						this.form.type = res.data.applytype
						this.form.cardpic = res.data.cardpic
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handff(val) {
				this.form.gooutdate = ''
				if (val) {
					this.form.gooutdate = val
				}
			},
			handcal(ev) {
				// console.log(ev)
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			onSelect(ev) {
				console.log(ev)
			},
			onPanelChange(value, mode) {
				console.log(value, mode);
			},
			resetForm(val) {
				if(!this.form.gooutdate){
					App.oTool.warningT('請选择日期');
					return 
				}
				if(!this.form.begintime || !this.form.endtime){
					App.oTool.warningT('請选择時間');
					return 
				}
				let begin = this.form.begintime.split(':'),
				end = this.form.endtime.split(':');
				if((end[0]*1>begin[0]*1)||(end[0]*1==begin[0]*1&&end[1]*1>begin[1]*1)){
					// ||(end[0]*1>begin[0]*1&&end[1]*1>=begin[1]*1)
				}else{
					App.oTool.warningT('外出時間不正確');
					return 
				}
				if(!this.form.cause){
					App.oTool.warningT('請輸入外出事由');
					return 
				}
				if(!this.form.address){
					App.oTool.warningT('請輸入外出地點');
					return 
				}
				if (this.showflag == 1) {
					if (!this.form.summarize) {
						App.oTool.warningT('請填寫外出總結');
						return
					}
				}
				
				
				this.form.type = '2' 
				this.form.issave = val 
				this.form.token = this.$store.state.token;
				// this.$refs[formName].resetFields();
				this.$ajax({
					method: 'post',
					url:this.showflag == 1 ? this.$api.newOutRecordSummarize : this.$api.newApply ,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {},
		}
	}
</script>

<style lang="scss">
	#homewaichu {
		input::-webkit-input-placeholder {
			font-size: 0.75rem;
		}
		.ant-upload.ant-upload-select{
			width: 100%;
		}
		.warp_bbtn {
			width: 100%;
			height: 1.75rem;
			font-size: .75rem;
			color: #000;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.titName {
			font-size: .75rem !important;
			color: #000;
		}

		.comname {
			font-size: .75rem !important;
		}

		.ant-modal {
			top: 12vh;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin: .2rem 0 .5rem;
		}

		.ant-form-item label {
			font-size: .75rem !important;
			width: 4rem;
		}

		.ant-input {
			font-size: .75rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: .75rem !important;
		}

		.ant-form-item-children {
			font-size: .75rem !important;
		}
	}
</style>
